import { render } from "./TeacherBottomNav.vue?vue&type=template&id=682f67c0&scoped=true"
import script from "./TeacherBottomNav.vue?vue&type=script&lang=js"
export * from "./TeacherBottomNav.vue?vue&type=script&lang=js"

import "./TeacherBottomNav.vue?vue&type=style&index=0&id=682f67c0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-682f67c0"]])

export default __exports__